import React from 'react';

function BannerImageLoading() {
  return <div className="banner bg-n-600 skeleton" />;
}

export default BannerImageLoading;
